<template>
  <div class="container__forum-thread container__comment">
    <ForumForm
      ref="forum-form__container"
      button-title="Save"
      :reference-meta="referenceMeta"
      :edited-data="editedData"
      :provider="onSave"
      @submit:invalid="onSubmitInvalid"
      @submit:success="onSubmitSuccess"
      @submit:error="onSubmitError"
      @cancel="onCancel"
    />
  </div>
</template>

<script>
import ForumThreads from '@/models/ForumThreads';
import { notificationMixin } from '@/mixins/notificationMixin';
import ForumForm from '@/components/Forum/ForumForm.vue';
export default {
  components: {
    ForumForm
  },
  mixins: [notificationMixin],
  props: {
    forumThread: {
      type: ForumThreads,
      default: () => {}
    }
  },
  data() {
    return {
      referenceMeta: {
        ref: 'forum-threads',
        refId: this.forumThread.id,
        field: 'images'
      },
      isEditing: false
    };
  },

  computed: {
    editedData() {
      const { content = '', images = [] } = this.forumThread;

      return {
        content,
        images
      };
    }
  },

  methods: {
    async onSave(body) {
      const { content, images } = body;

      await ForumThreads.api().updateForumThread(this.forumThread.forum_id, this.forumThread.id, {
        content,
        images
      });

      return ForumThreads.find(this.forumThread.id);
    },

    async onSubmitSuccess(editedForumThread) {
      await ForumThreads.api().getForumThreadById(this.forumThread.forum_id, editedForumThread.id);

      this.$emit('save');
      this.$toast.success('Comment was updated successfully');
    },
    onSubmitError() {
      this.$toast.error('Cannot update comment, please try again');
    },
    onSubmitInvalid() {
      this.$toast.error('Cannot update comment, please check error messages');
    },
    onCancel() {
      return this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss">
.container__forum-thread {
  display: flex;
  flex-direction: column;

  .text__forum-topic {
    color: #3b3e66;
    font-weight: 600;
    font-size: 1.25rem;
  }

  .lu-owner-detail {
    display: flex;
    flex-direction: row;
    gap: 0 0.5rem;
  }

  .text__owner-detail {
    display: flex;
    flex-direction: column;
  }

  .text__owner-detail > .text__fullname {
    color: #3c44b1;
    font-weight: 600;
    font-size: 1rem;
  }

  .text__owner-detail > .text__role {
    color: #7a7b97;
    font-weight: 400;
    font-size: 0.75rem;
  }

  .text__date {
    font-weight: 500;
    font-size: 1rem;
  }
}
</style>
